import { render, staticRenderFns } from "./perintah-kerja.vue?vue&type=template&id=05c67273"
import script from "./perintah-kerja.vue?vue&type=script&lang=js"
export * from "./perintah-kerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports